import type { Pendo } from './pendo'
import type { RumGlobal } from '@datadog/browser-rum'

export type { Pendo, RumGlobal }

declare global {
  interface Window {
    pendo?: Pendo
    DD_RUM?: RumGlobal
  }
}

export const getPendo = (): Pendo | undefined => {
  return window.pendo
}

export const getDatadogRum = (): RumGlobal | undefined => {
  return window.DD_RUM
}
